import { render } from "./CustomMade.vue?vue&type=template&id=43037948"
const script = {}

import "./CustomMade.vue?vue&type=style&index=0&id=43037948&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__